import packageInfo from '../package.json'

const commands = ['version', 'v', 'deleteAllCookies', 'del', 'help', 'ajuda']

Object.defineProperty(window, commands[0], {
  get: (): string => `Current version: ${packageInfo.version}`,
})

Object.defineProperty(window, commands[1], {
  get: (): string => `Current version: ${packageInfo.version}`,
})

Object.defineProperty(window, commands[2], {
  get: (): string => {
    const cookies = document.cookie.split(';')

    for (const cookie of cookies) {
      const eqPos = cookie.indexOf('=')
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
    }

    console.log('cookies: ', document.cookie)
    window.location.reload()

    return `Cookies removidos`
  },
})

Object.defineProperty(window, commands[3], {
  get: (): string => {
    const cookies = document.cookie.split(';')

    for (const cookie of cookies) {
      const eqPos = cookie.indexOf('=')
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
    }

    console.log('cookies: ', document.cookie)
    window.location.reload()

    return `Cookies removidos`
  },
})

Object.defineProperty(window, commands[4], {
  get: (): string => {
    // list all commands
    return commands.join(', ')
  },
})
